var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: _vm.userLevelClass },
    [
      !_vm.userLevel
        ? _c(
            "div",
            {
              class: [
                {
                  "yxtbiz-user-medal__flex-start d-in-block pull-left":
                    _vm.levelMode === "row",
                },
                { "yxtbiz-user-medal__flex-center": _vm.levelMode !== "row" },
              ],
            },
            [
              _vm.count > -1
                ? _c(
                    "div",
                    { class: _vm.medalClass, on: { click: _vm.onClick } },
                    [
                      _c("yxtf-svg", {
                        attrs: {
                          width: "14px",
                          height: "16px",
                          "icon-class": "medal-biz",
                          "remote-url": _vm.mediaPath,
                        },
                      }),
                      _c("span", { staticClass: "ml3" }, [
                        _vm._v(_vm._s(_vm.formatCount())),
                      ]),
                      _c("span", { staticClass: "ml2" }, [
                        _vm._v(_vm._s(_vm.medalString)),
                      ]),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.levelNum > -1
                ? _c(
                    "div",
                    {
                      class: _vm.levelIconClass,
                      on: { click: _vm.onLevelClick },
                    },
                    [_c("span", [_vm._v("Lv." + _vm._s(_vm.levelNum))])]
                  )
                : _vm._e(),
            ]
          )
        : _vm._e(),
      !_vm.userLevel && _vm.levelNum > -1 && _vm.isSelf
        ? _c(
            "div",
            { class: _vm.levelTextClass, on: { click: _vm.onLevelClick } },
            [
              _vm._v("\n    " + _vm._s(_vm.levelExpString) + " "),
              _c("span", { staticClass: "yxt-weight-6" }, [
                _vm._v(_vm._s(_vm.exp)),
              ]),
              _vm._v("/" + _vm._s(_vm.maxExp) + "\n  "),
            ]
          )
        : _vm._e(),
      !_vm.userLevel ? _c("user-medal-info", { ref: "medal" }) : _vm._e(),
      _vm.userLevel && Number(_vm.userLevel) > -1
        ? _c("span", [_vm._v("Lv." + _vm._s(_vm.userLevel))])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }